import React from 'react';
import cn from 'classnames';

import { idxMap } from 'helpers/styleMapIdx';

import type { StripCell } from '../../TimelineSection.helpers';

import styles from './SessionStrip.module.scss';

const CELL_VARIANTS = {
  normal: styles.cellNormal,
  error: styles.cellError,
  slow: styles.cellSlow,
  goal: styles.cellGoal,
  gap: styles.cellGap,
};

/** Compressed event rhythm of a session: one cell per event, gaps ≥ 4 min dashed. */
const SessionStrip = ({
  className,
  highlighted = false,
  strip,
}: {
  className?: string;
  highlighted?: boolean;
  strip: StripCell[];
}) =>
  strip.length > 0 ? (
    <div
      className={cn(
        styles.strip,
        { [styles.stripHighlighted]: highlighted },
        className,
      )}
      aria-hidden
    >
      {strip.map((cell, cellIndex) => (
        <span
          key={cellIndex}
          className={cn(
            styles.cell,
            idxMap(CELL_VARIANTS as Record<string, string>, cell),
          )}
        />
      ))}
    </div>
  ) : null;

export default React.memo(SessionStrip) as any;
